var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54583 12.5625H11.1413V17.1579C11.1413 17.625 11.5255 18.0167 12.0001 18.0167C12.4747 18.0167 12.8589 17.625 12.8589 17.1579V12.5625H17.4543C17.9214 12.5625 18.3131 12.1783 18.3131 11.7037C18.3131 11.2291 17.9214 10.8449 17.4543 10.8449H12.8589V6.24944C12.8589 5.78237 12.4747 5.39062 12.0001 5.39062C11.5255 5.39062 11.1413 5.78237 11.1413 6.24944V10.8449H6.54583C6.07875 10.8449 5.68701 11.2291 5.68701 11.7037C5.68701 12.1783 6.07875 12.5625 6.54583 12.5625Z",
    fill: "#0478FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.0d4aa86d678e32848cc6765cb1cc16d1.svg";
export { ForwardRef as ReactComponent };